import {Component, OnInit} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {VerityPriceModel} from '../../../utils/models/verity-price-model';
import {TableDetailsService} from '../../../utils/services/table-details.service';
import {VeritiyPricesTableRowModel} from '../../models/verity-prices-table-row-model';
import {DefaultExporterComponent} from '../../../utils/components/export/DefaultExporterComponent';
import {VerityPriceTableStates} from './verity-prices-table-states';

@Component({
    selector: 'app-verity-prices-table',
    templateUrl: './verity-prices-table.component.html',
    styleUrls: ['./verity-prices-table.component.css']
})
export class VerityPricesTableComponent extends DefaultExporterComponent implements OnInit {

    selection = new SelectionModel<VerityPriceModel>(true, []);
    dataLoaded = false;

    constructor(private tableDetailsService: TableDetailsService) {
        super();
        this.initTableColumns();
    }

    ngOnInit() {
        this.http.post('/getdatapoints/', {})
            .subscribe((response: VerityPriceModel[]) => {
                this.tableInput = response;

                this.dataLoaded = true;
            }, error => {
                this.dataLoaded = true;
            });
    }

    onTableViewChange($event) {
        switch ($event) {
            case VerityPriceTableStates.EXTERNAL:
                this.showColumns(['ExF_excl_VAT', 'ExF_excl_VAT_flag', 'WHS_excl_VAT', 'WHS_excl_VAT_flag', 'Ret_excl_VAT',
                    'Ret_excl_VAT_flag', 'Ret_incl_VAT', 'Ret_incl_VAT_flag']);
                break;

            case VerityPriceTableStates.INTERNAL:
                this.showColumns(['ExF_excl_VAT', 'ExF_excl_VAT_flag']);
                this.hideColumns(['WHS_excl_VAT', 'WHS_excl_VAT_flag', 'Ret_excl_VAT',
                    'Ret_excl_VAT_flag', 'Ret_incl_VAT', 'Ret_incl_VAT_flag']);
                break;
        }
    }

    private showColumns(keys: Array<string>) {
        keys.forEach(key => this.changeColumnVisibility(key, true));
    }

    private hideColumns(keys: Array<string>) {
        keys.forEach(key => this.changeColumnVisibility(key, false));
    }

    private changeColumnVisibility(key: string, visible: boolean) {
      const col = this.tableColumns.find(column => column.key === key);
      col.visible = visible;
    }

    private initTableColumns() {
        this.tableColumns = [
            new VeritiyPricesTableRowModel(1, 100, 'Country', 'Country_name', true, 'left', true),
            new VeritiyPricesTableRowModel(2, 100, 'Company', 'Manufacturer', true, 'left', true),
            new VeritiyPricesTableRowModel(3, 110, 'Likely Parallel Trade', 'parallel_trade', true, 'left', true),
            new VeritiyPricesTableRowModel(4, 100, 'Brand', 'International_Brand_Name', true, 'left', true),
            new VeritiyPricesTableRowModel(5, 100, 'INN', 'INN', true, 'left', true),
            new VeritiyPricesTableRowModel(6, 100, 'ATC', 'ATC', true, 'left', true),
            new VeritiyPricesTableRowModel(7, 100, 'Strength', 'Strength', true, 'left', true),
            new VeritiyPricesTableRowModel(8, 100, 'Form', 'Form', true, 'left', true),
            new VeritiyPricesTableRowModel(9, 100, 'Pack size', 'Package_size', true, 'right'),
            new VeritiyPricesTableRowModel(10, 100, 'Package', 'Package_type', true, 'left'),
            new VeritiyPricesTableRowModel(11, 100, 'SKU Details', 'SKU_detail', true, 'left'),
            new VeritiyPricesTableRowModel(12, 100, 'Currency', 'Loc_Currency', true, 'left'),
            new VeritiyPricesTableRowModel(13, 100, 'Ex-Factory list price', 'ExF_excl_VAT', true, 'right'),
            new VeritiyPricesTableRowModel(14, 100, 'ExFactory list price flag', 'ExF_excl_VAT_flag', true, 'left'),
            new VeritiyPricesTableRowModel(15, 130, 'Wholesale price', 'WHS_excl_VAT', true, 'right'),
            new VeritiyPricesTableRowModel(16, 100, 'Wholesale price flag', 'WHS_excl_VAT_flag', true, 'left'),
            new VeritiyPricesTableRowModel(17, 130, 'Pharmacy price without VAT', 'Ret_excl_VAT', true, 'right'),
            new VeritiyPricesTableRowModel(18, 130, 'Pharmacy price without VAT flag', 'Ret_excl_VAT_flag', true, 'left'),
            new VeritiyPricesTableRowModel(19, 110, 'Pharmacy price with VAT', 'Ret_incl_VAT', true, 'right'),
            new VeritiyPricesTableRowModel(20, 110, 'Pharmacy price with VAT flag', 'Ret_incl_VAT_flag', true, 'left'),
            new VeritiyPricesTableRowModel(21, 130, 'Last found date', 'last_found_dttm', true, 'right'),
            new VeritiyPricesTableRowModel(30, 100, 'SKU_id', 'SKU_id', true, 'left'),
            new VeritiyPricesTableRowModel(31, 100, 'Loc_Product_cd', 'Loc_Product_cd', true, 'left'),
        ];

        this.tableDetailsService.addSkuDetails(this.tableColumns);
    }
}
